import AdminAddPasein from "../../components/AdminAppointment/AppointmentAdd";

export default function AddPasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminAddPasein/>
    </div>
  );
}
